module.exports = __webpack_public_path__ + "img/TractionAndroid2.6b9d9a00.png";